<template>
  <div
    :class="{'active': isActive}"
    class="category">
    <div
      class="btn py-2"
      @click="click()">
      <div class="label">{{ label }}</div>
    </div>
    <div v-if="isActive">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    to: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  computed: {
    isActive() {
      const compare = /^\/([-_a-zA-Z]*)\/?/.exec(this.$router.resolve(this.to).resolved.fullPath);
      const current = /^\/([-_a-zA-Z]*)\/?/.exec(this.$route.fullPath);
      if (compare && current) {
        if (compare.input === current.input) {
          return true;
        }
      }

      if (this.$route.name && this.$route.name.indexOf(this.to.name) >= 0) {
        return true;
      }

      return false;
    },
  },
  methods: {
    click() {
      this.$router.push(this.to);
    },
  },
};
</script>

<style lang="scss" scoped>
.category {
  .btn {
    font-weight: 600;
  }

  &.active {
    background: rgba(0, 0, 0, 0.07);
    border-right: 4px solid $info;

    .btn {
      color: $info;
    }
  }

  /deep/ .btn {
    background: rgba(0, 0, 0, 0);
    border-radius: 0;
    text-align: left;
    display: block;
    width: 100%;

    &:hover {
      color: $black;
      background: rgba(0, 0, 0, 0.12);
    }
  }

  /deep/ .label,
  /deep/ .short-label {
    display: inline-block;
    transition: opacity ease 0.4s, width ease 0.4s;
    overflow: hidden;
    white-space: nowrap;
    opacity: 1;
  }

  /deep/ .label {
    width: 11rem;
  }
}
</style>
